import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_invoices_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId?: number, projectId?: number, statusIds?: number[], fullTextSearch?: string, createdFrom?: string, createdTo?: string }): 
  Promise<{ result: { Id?: number, AttentionOf?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, DueDate?: string, InvoiceDate?: string, LookupCode?: string, Notes?: string, ReferenceCode?: string, Status?: { Name?: string }, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, InvoiceLines?: { Id?: number, BillingRecords?: { BillingTaskId?: number, BillingTask?: { ShipmentId?: number, WarehouseId?: number, Warehouse?: { Name?: string }, Shipment?: { LookupCode?: string } } }[] }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_invoices_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId?: number, projectId?: number, statusIds?: number[], fullTextSearch?: string, createdFrom?: string, createdTo?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AttentionOf?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, DueDate?: string, InvoiceDate?: string, LookupCode?: string, Notes?: string, ReferenceCode?: string, Status?: { Name?: string }, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, InvoiceLines?: { Id?: number, BillingRecords?: { BillingTaskId?: number, BillingTask?: { ShipmentId?: number, WarehouseId?: number, Warehouse?: { Name?: string }, Shipment?: { LookupCode?: string } } }[] }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_invoices_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId?: number, projectId?: number, statusIds?: number[], fullTextSearch?: string, createdFrom?: string, createdTo?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, AttentionOf?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, DueDate?: string, InvoiceDate?: string, LookupCode?: string, Notes?: string, ReferenceCode?: string, Status?: { Name?: string }, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, InvoiceLines?: { Id?: number, BillingRecords?: { BillingTaskId?: number, BillingTask?: { ShipmentId?: number, WarehouseId?: number, Warehouse?: { Name?: string }, Shipment?: { LookupCode?: string } } }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_invoices_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
